import axios from "axios";
import authHeader from "../../Services/auth-header";
import { refreshToken } from "../../Services/auth.service";
import GetBasketZipcode from "../GetBasketZipcode";
import { baseURLGetCart } from "../../Services/client";

export function createGetHasZipcode({
  isLoggedIn,
  setHasZipcode,
  setZipcode,
  setZipcodeButton,
  setHasInstall,
}) {
  return function getHasZipcode() {
    GetBasketZipcode(isLoggedIn)
      .then((temp) => {
        if (temp === 401) {
          getHasZipcode();
        } else if (temp && temp !== "") {
          setHasZipcode(temp);
          setZipcode(temp);
          setZipcodeButton(true);
          setHasInstall(true);
        } else {
          setHasZipcode("");
          setZipcode("");
          setZipcodeButton(false);
          setHasInstall(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setHasZipcode("");
        setZipcode("");
        setZipcodeButton(false);
        setHasInstall(false);
      });
  };
}

export function createGetCart({
  isLoggedIn,
  cartChanged,
  setBag,
  setCartChanged,
}) {
  return async function getCart() {
    return await new Promise((resolve, reject) => {
      if (isLoggedIn) {
        axios
          .get(baseURLGetCart, {
            headers: authHeader(),
          })
          .then((response) => {
            setBag(response.data ? response.data : {});
            resolve(response.data ? response.data : {});
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  setCartChanged(cartChanged + 1);
                  reject();
                } else {
                  setCartChanged(cartChanged + 1);
                  reject();
                }
              });
            } else {
              reject();
            }
          });
      } else {
        if (localStorage.getItem("cart") !== null) {
          setBag(JSON.parse(localStorage.getItem("cart")));
          resolve(JSON.parse(localStorage.getItem("cart")));
        } else {
          setBag({});
          resolve({});
        }
      }
    });
  };
}
